import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import i18next from "i18next";
import { useGetMainCurrencyByCountryId } from "@hooks/useGeneralParams";
import "./PriceList.scss";
import PrepareDataTable from "./PrepareDataTable";
import AddEditCenterProductPrice from "../AddEditCenterProductPrice/AddEditCenterProductPrice";
import { PriceListContainer } from "./PriceList.styled";

/**
 * Center Product Price List,
 * Path - /centre/product/view/{centerProductId}
 * @see See [CenterProductPrice Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2927722497/Centre+product+view+page+-+Prices)
 * @component
 */
const PriceList = (props) => {
  const {
    t,
    columnList,
    subCategoryId,
    centerProductStatus,
    companyId,
    centerId,
    centerProductId,
    countryId,
  } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const [isAddPricePopupVisible, setAddPricePopupVisible] = useState(false);
  const [transportTypes, setTransportTypes] = useState([]);
  const [defaultUserCurrency, setDefaultUserCurrency] = useState(0);
  const mainCurrencyByCountry = useGetMainCurrencyByCountryId(countryId);

  const createAddEditPrice = () => {
    setAddPricePopupVisible(true);
  };

  const closePricePopupVisible = () => {
    setAddPricePopupVisible(false);
  };
  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  useEffect(() => {
    if (!countryId) return;
    axios
      .get(
        `/transports?status=1&countries=${countryId}&orderBy=asc&limit=-1`,
        {}
      )
      .then((response) => {
        const responseData = response.data.transports.map((item) => {
          const tempData = {
            value: item.id,
            label: item.name,
          };
          return tempData;
        });
        setTransportTypes(responseData);
      })
      .catch((error) => {});
  }, [countryId]);

  useEffect(() => {
    if (!defaultUserCurrency && mainCurrencyByCountry) {
      setDefaultUserCurrency(mainCurrencyByCountry);
    }
  }, [mainCurrencyByCountry]);

  return (
    <PriceListContainer className="center-product-price-list">
      <PrepareDataTable
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        centreId={centerId}
        centreProductId={centerProductId}
        companyId={companyId}
        centerProductStatus={centerProductStatus}
        createCenterProductPrice={createAddEditPrice}
        transportTypes={transportTypes}
        countryId={countryId}
      />
      {isAddPricePopupVisible && (
        <AddEditCenterProductPrice
          title={t("PRODUCT")}
          onClose={closePricePopupVisible}
          updateRefeshStatus={updateRefeshStatus}
          subCategoryId={subCategoryId}
          transportTypes={transportTypes}
          actionType="create"
          defaultUserCurrency={defaultUserCurrency}
          companyId={companyId}
          centerId={centerId}
          centerProductId={centerProductId}
          countryId={countryId}
        />
      )}
    </PriceListContainer>
  );
};

PriceList.propTypes = {
  t: PropTypes.func.isRequired,
  companyId: PropTypes.number,
  centerId: PropTypes.number,
  centerProductId: PropTypes.number,
  centerProductStatus: PropTypes.number,
  countryId: PropTypes.number,
};

PriceList.defaultProps = {
  centerProductStatus: 0,
};

export default withTranslation()(PriceList);
